import { ApiGateway } from '@/modules/api/api.gateway'
import { IConfigRepository } from '@/modules/config/core/config.repository.interface'
import { ConfigResponseDto } from '@/modules/config/core/config.types'

export class ConfigRepository implements IConfigRepository {
  constructor(private api: ApiGateway) {}

  async getAll(): Promise<ConfigResponseDto> {
    return this.api.get<ConfigResponseDto>('config')
  }
}
